import axios from "axios";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const CitizenAggressorsListService = {
    list: async () => axios.get(API_KEEPER + "/sos/aggressors-list").then(({data}) => data).catch((err) => { throw err }),

    visitList: async (cpf) => axios.get(API_KEEPER + "/sos/aggressors-list/visit/" + cpf).then(({data}) => data).catch((err) => { throw err }),
};

export default CitizenAggressorsListService;